















import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import { HistoryByStudentData } from '@/mixins/requests/branch/HistoryByStudentApis.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class HistoryByStudentTable extends Vue {
  @Prop()
  private historyByStudentList!: HistoryByStudentData
  @Prop()
  private onClickComfirmButton!: (studyContentId: number) => void
}
